package co.maytes.standupbot.dashboard.components.feedback

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.cssRgb
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Spacing
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val SkeletonPulseStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("animation", "sb-fade-pulse 1.2s ease-in-out infinite")
        }
    }
}

@Composable
fun SkeletonRow(height: CSSSizeValue<CSSUnit.px> = 72.px) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(height)
            .margin(bottom = Spacing.md)
            .padding(Spacing.lg)
            .backgroundColor(Palette.surface)
            .borderRadius(Radius.md)
            .styleModifier {
                property("border", "1px solid ${Palette.border.cssRgb()}")
            },
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            SkeletonBar(widthPercent = 40, heightPx = 14)
            Row(modifier = Modifier.margin(top = Spacing.sm)) {
                SkeletonBar(widthPercent = 20, heightPx = 10)
            }
        }
    }
}

@Composable
fun SkeletonChart() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = Spacing.md)
            .padding(Spacing.lg)
            .backgroundColor(Palette.surface)
            .borderRadius(Radius.md)
            .styleModifier {
                property("border", "1px solid ${Palette.border.cssRgb()}")
            },
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            SkeletonBar(widthPercent = 28, heightPx = 14)
            Row(modifier = Modifier.margin(top = Spacing.xs)) {
                SkeletonBar(widthPercent = 42, heightPx = 10)
            }
            Box(
                modifier = SkeletonPulseStyle.toModifier()
                    .fillMaxWidth()
                    .margin(top = Spacing.lg)
                    .height(220.px)
                    .backgroundColor(Palette.surfaceSubtle)
                    .borderRadius(Radius.md),
            )
        }
    }
}

@Composable
private fun SkeletonBar(widthPercent: Int, heightPx: Int) {
    Box(
        modifier = SkeletonPulseStyle.toModifier()
            .width(widthPercent.percent)
            .height(heightPx.px)
            .backgroundColor(Palette.surfaceSubtle)
            .borderRadius(Radius.sm),
    )
}

